"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = exports.update = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

/* eslint-disable no-underscore-dangle */
var scope = typeof window === "undefined" ? global : window;
var settings = scope.__boomComponentsSettings || {};
scope.__boomComponentsSettings = scope.__boomComponentsSettings || settings;
var update = function update(name) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  settings[name] = (0, _objectSpread2["default"])({}, config, settings[name] || {});
  return settings[name];
};
exports.update = update;
var get = function get(name) {
  return settings[name];
};
exports.get = get;